<template>
  <div>
    <div class="text-center" v-if="!dataLoaded">
      <v-progress-circular class="mt-6" :size="50" color="primary" indeterminate />
    </div>

    <div class="mt-4" v-else>

      <v-row class="my-0">
        <v-col cols="12" class="pt-0">
          <v-row>
            <v-col cols="12" md="7" class="d-flex">
              <v-btn
                class="white--text px-4 mr-2"
                small outlined rounded color="primary"
                @click="$router.push({name: 'protocols'})"
              >
                <v-icon left small>mdi-chevron-left</v-icon>
                Назад
              </v-btn>

              <v-btn
                outlined small rounded
                color="primary"
                class="white--text px-4"
                @click="dialog = true"
              >
                <v-icon left small>mdi-plus</v-icon>Добавить
              </v-btn>
            </v-col>
          </v-row>

          <PageTable
            :table-loading="tableLoading"
            :table-headers="tableHeaders"
            :table-items="protocolLinesDTO.list"
            filter
          >
            <template v-slot:item.decision.name="{ item: application }">
              <v-edit-dialog
                :return-value.sync="application.decision"
                large persistent
                save-text="сохранить"
                cancel-text="отмена"
                @save="saveDecision(application)"
              >
                <div>
                  {{ application.decision.name }}
                  <v-icon small color="lightGrey">mdi-pencil-outline</v-icon>
                </div>
                <template v-slot:input>
                  <v-autocomplete
                    class="mt-2"
                    label="Решение" placeholder="Выберите из списка" no-data-text="Список пуст"
                    v-model="application.decision"
                    :items="decisions" item-text="name"
                    outlined rounded dense return-object hide-details
                  />
                </template>
              </v-edit-dialog>
            </template>

            <template v-slot:item.actions="{ item }">
<!--              <v-icon color="lightGrey" class="mr-1 eye-btn" size="22" title="Просмотр" @click="show(item)">-->
<!--                mdi-eye-outline-->
<!--              </v-icon>-->
<!--              <v-icon color="lightGrey" class="mr-1 edit-btn" size="22" title="Редактировать" @click="edit(item)">-->
<!--                mdi-pencil-outline-->
<!--              </v-icon>-->
              <v-icon color="lightGrey" class="remove-btn" size="22" title="Удалить" @click="remove(item)">
                mdi-trash-can-outline
              </v-icon>
            </template>
          </PageTable>
        </v-col>
      </v-row>
    </div>

    <ProtocolLineDialog
      :dialog="dialog"
      :saveBtnLoading="btnLoading"
      :selectedItem="selectedItem"
      :isShowMode="isShowMode"
      @saveProtocolLine="saveProtocolLine"
      @closeModal="closeDialog"
    />

    <ConfirmDialog
      :dialog="confirmDialog"
      :loading="btnLoading"
      :message="`Вы уверены, что хотите удалить значение из справочника?`"
      @confirm="removeProtocolLine"
      @closeModal="closeDialog"
    />
  </div>
</template>

<script>
import {
  decisionApi,
  protocolApi,
  protocolLineApi
} from '@/api'
import { ProtocolLineDtoList } from '@/models'
import PageTable from '@/components/ui/Table'
import ProtocolLineDialog from '@/components/zvp/documentationSetup/dialogs/ProtocolLineDialog'
import ConfirmDialog from '@/components/dialogs/ConfirmDelete'

export default {
  name: 'ProtocolLine',

  components: {
    PageTable,
    ProtocolLineDialog,
    ConfirmDialog
  },

  async created() {
    await this.$store.dispatch('user/getCurrent')

    this.protocolId = this.$route.params.id

    await this.getCatalogs()
    await this.getProtocolLines()
    this.dataLoaded = true
  },

  data: () => ({
    tableHeaders: [
      { text: 'ФИО', value: 'fullName', sortable: false, align: 'start'},
      { text: 'Результат тестирования', value: 'testScore', sortable: false, align: 'start'},
      { text: 'Курс', value: 'courseNumberTo.name', sortable: false, align: 'start'},
      { text: 'Основа обучения', value: 'paidFormTo.name', sortable: false, align: 'start'},
      { text: 'Специальность', value: 'specialityTo.name', sortable: false, align: 'start'},
      { text: 'Тип заявления', value: 'applicationType.name', sortable: false, align: 'start'},
      { text: 'Решение', value: 'decision.name', sortable: false, align: 'start'},
      { text: 'Действия', value: 'actions', sortable: false, align: 'center', width: '50px' },
    ],

    protocolLinesDTO: new ProtocolLineDtoList(),

    decisions: [],

    selectedItem: null,
    isShowMode: false,

    btnLoading: false,
    dataLoaded: false,
    tableLoading: false,

    dialog: false,
    confirmDialog: false,

    protocolId: null,
  }),

  methods: {
    async getCatalogs() {
      const [decisions] = await Promise.all([decisionApi.getCatalog()])

      this.decisions = decisions
    },

    async getProtocolLines() {
      try {
        this.tableLoading = true
        const data = await protocolLineApi.findAllByProtocolId(this.protocolId)
        this.protocolLinesDTO = new ProtocolLineDtoList(data)
      } catch (e) {
        this.showErrorMessage(e, 'Возникла ошибка')
      } finally {
        this.tableLoading = false
      }
    },

    show(item) {
      this.selectedItem = item
      this.dialog = true
      this.isShowMode = true
    },

    edit(item) {
      this.selectedItem = item
      this.dialog = true
    },

    remove(item) {
      this.selectedItem = item
      this.confirmDialog = true
    },

    async saveDecision(body) {
      try {
        await protocolLineApi.addDecision(body)
        this.$toastr('success', '', 'Успешно сохранено')
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка сохранения')
      }
    },

    async saveProtocolLine(body) {
      body.protocol = {id: this.protocolId}
      try {
        this.btnLoading = true

        body.id ? await protocolLineApi.update(body) : await protocolLineApi.create(body)
        await this.getProtocolLines()
        this.$toastr('success', '', 'Успешно сохранено')
        this.closeDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка сохранения')
      } finally {
        this.btnLoading = false
      }
    },

    async removeProtocolLine() {
      try {
        this.btnLoading = true

        await protocolLineApi.remove(this.selectedItem.id)
        this.protocolLinesDTO.remove(this.selectedItem.id)
        this.$toastr('success', '', 'Успешно удалено')
        this.closeDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка удаления')
      } finally {
        this.btnLoading = false
      }
    },

    closeDialog() {
      this.confirmDialog = false
      this.dialog = false
      this.selectedItem = null
      this.isShowMode = false
    },
  },
}
</script>

<style scoped>
</style>
